import { type ParsedUrlQuery } from 'node:querystring';

import { QueryParamNames } from '~/constants/search';

export const getWorkspaceNameFromQuery = (query: ParsedUrlQuery): string | undefined => {
  const value = query[QueryParamNames.workspaceName];

  return typeof value === 'string' ? value : undefined;
};
